import React from "react";

import styles from "./select_separator.module.scss";

export default function SelectSeparator({ children }) {
  return <div className={styles.separator}>{children}</div>;
}
